import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanyType } from 'src/app/interfaces/company-type';
import { Jurisdiction } from 'src/app/interfaces/jurisdiction';

import { AddressForm } from './address-form';
import { ContactForm } from './contact-form';

export class ClientRegisteredVendorForm extends FormGroup<{
  id: FormControl<undefined | number>;
  legalName: FormControl<undefined | string>;
  dba: FormControl<null | string>;
  ein: FormControl<null | string>;
  ssn: FormControl<null | string>;
  bsn: FormControl<null | string>;
  rsn: FormControl<null | string>;
  usesSIN: FormControl<undefined | boolean>;
  website: FormControl<null | string>;
  companyType: FormControl<null | CompanyType>;
  isSoleProprietorship: FormControl<undefined | boolean>;
  taxIdentification: FormControl<null | ('EIN' | 'SSN')>;
  llcType: FormControl<null | ('C' | 'S' | 'P' | 'disregardedEntity')>;
  jurisdiction: FormControl<null | Jurisdiction>;
  address1: FormControl<string | null>;
  address2: FormControl<string | null>;
  city: FormControl<string | null>;
  state: FormControl<string | null>;
  zip: FormControl<string | null>;
  country: FormControl<undefined | ('US' | 'CA')>;
  phone: FormControl<string | null>;
  phone2: FormControl<string | null>;
  fax: FormControl<string | null>;
  mailingAddress1: FormControl<string | null>;
  mailingAddress2: FormControl<string | null>;
  mailingCity: FormControl<string | null>;
  mailingState: FormControl<string | null>;
  mailingZip: FormControl<string | null>;
  isOnSite: FormControl<boolean | undefined>;
  isProfessional: FormControl<undefined | boolean>;
  isSupplier: FormControl<undefined | boolean>;
  createdAt: FormControl<undefined | Date>;
  updatedAt: FormControl<undefined | Date>;
  claimCode: FormControl<null | string>;
  isClaimed: FormControl<undefined | boolean>;
  VendorId: FormControl<null | number>;
  CompanyId: FormControl<undefined | number>;
  requesterFirstName: FormControl<null | string>;
  requesterLastName: FormControl<null | string>;
  preventRenewalInactivation: FormControl<undefined | boolean>;
  stateToVerify: FormControl<
    | null
    | (
        | 'AL'
        | 'AK'
        | 'AR'
        | 'AZ'
        | 'CA'
        | 'CO'
        | 'CT'
        | 'DC'
        | 'DE'
        | 'FL'
        | 'GA'
        | 'HI'
        | 'IA'
        | 'ID'
        | 'IL'
        | 'IN'
        | 'KS'
        | 'KY'
        | 'LA'
        | 'MA'
        | 'MD'
        | 'ME'
        | 'MI'
        | 'MN'
        | 'MO'
        | 'MS'
        | 'MT'
        | 'NC'
        | 'ND'
        | 'NE'
        | 'NH'
        | 'NJ'
        | 'NM'
        | 'NV'
        | 'NY'
        | 'OH'
        | 'OK'
        | 'OR'
        | 'PA'
        | 'RI'
        | 'SC'
        | 'SD'
        | 'TN'
        | 'TX'
        | 'UT'
        | 'VA'
        | 'VT'
        | 'WA'
        | 'WI'
        | 'WV'
        | 'WY'
        | 'AB'
        | 'BC'
        | 'MB'
        | 'NB'
        | 'NL'
        | 'NS'
        | 'NU'
        | 'ON'
        | 'PE'
        | 'QC'
        | 'SK'
        | 'NT'
        | 'YT'
      )
  >;
  issue1099: FormControl<undefined | boolean>;
  isArchived: FormControl<undefined | boolean>;
  accountingId: FormControl<string | null>;
  isTakeOver: FormControl<boolean>;
  isOffsite: FormControl<boolean>;
  forceTempActive: FormControl<boolean>;

  Addresses: FormArray<AddressForm>;
  StreetAddress: AddressForm;
  MailingAddress: AddressForm;

  Contacts: FormArray<ContactForm>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      legalName: new FormControl<undefined | string>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      dba: new FormControl<null | string>(null),
      ein: new FormControl<null | string>(null),
      ssn: new FormControl<null | string>(null),
      bsn: new FormControl<null | string>(null),
      rsn: new FormControl<null | string>(null),
      usesSIN: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      website: new FormControl<null | string>(null),
      companyType: new FormControl<null | CompanyType>(null),
      isSoleProprietorship: new FormControl<undefined | boolean>(false, {
        nonNullable: true
      }),
      taxIdentification: new FormControl<null | ('EIN' | 'SSN')>(null),
      jurisdiction: new FormControl<null | Jurisdiction>(null),
      address1: new FormControl<null | string>(null),
      address2: new FormControl<null | string>(null),
      city: new FormControl<null | string>(null),
      state: new FormControl<null | string>(null),
      zip: new FormControl<null | string>(null),
      country: new FormControl<undefined | ('US' | 'CA')>('US', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      phone: new FormControl<null | string>(null),
      phone2: new FormControl<null | string>(null),
      fax: new FormControl<null | string>(null),
      mailingAddress1: new FormControl<null | string>(null),
      mailingAddress2: new FormControl<null | string>(null),
      mailingCity: new FormControl<null | string>(null),
      mailingState: new FormControl<null | string>(null),
      mailingZip: new FormControl<null | string>(null),
      isOnSite: new FormControl<boolean | undefined>(false, {
        nonNullable: true
      }),
      isProfessional: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isSupplier: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      createdAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      }),
      updatedAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      }),
      claimCode: new FormControl<null | string>(null),
      isClaimed: new FormControl<undefined | boolean>(false, {
        nonNullable: true
      }),
      VendorId: new FormControl<null | number>(null),
      CompanyId: new FormControl<undefined | number>(undefined, {
        nonNullable: true
      }),
      requesterFirstName: new FormControl<null | string>(null),
      requesterLastName: new FormControl<null | string>(null),
      preventRenewalInactivation: new FormControl<undefined | boolean>(false, {
        nonNullable: true
      }),
      stateToVerify: new FormControl<
        | null
        | (
            | 'AL'
            | 'AK'
            | 'AR'
            | 'AZ'
            | 'CA'
            | 'CO'
            | 'CT'
            | 'DC'
            | 'DE'
            | 'FL'
            | 'GA'
            | 'HI'
            | 'IA'
            | 'ID'
            | 'IL'
            | 'IN'
            | 'KS'
            | 'KY'
            | 'LA'
            | 'MA'
            | 'MD'
            | 'ME'
            | 'MI'
            | 'MN'
            | 'MO'
            | 'MS'
            | 'MT'
            | 'NC'
            | 'ND'
            | 'NE'
            | 'NH'
            | 'NJ'
            | 'NM'
            | 'NV'
            | 'NY'
            | 'OH'
            | 'OK'
            | 'OR'
            | 'PA'
            | 'RI'
            | 'SC'
            | 'SD'
            | 'TN'
            | 'TX'
            | 'UT'
            | 'VA'
            | 'VT'
            | 'WA'
            | 'WI'
            | 'WV'
            | 'WY'
            | 'AB'
            | 'BC'
            | 'MB'
            | 'NB'
            | 'NL'
            | 'NS'
            | 'NU'
            | 'ON'
            | 'PE'
            | 'QC'
            | 'SK'
            | 'NT'
            | 'YT'
          )
      >(null),
      llcType: new FormControl<null | ('C' | 'S' | 'P' | 'disregardedEntity')>(
        null
      ),
      issue1099: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isArchived: new FormControl<undefined | boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      accountingId: new FormControl<string | null>(null),
      isTakeOver: new FormControl<boolean>(false, { nonNullable: true }),
      isOffsite: new FormControl<boolean>(false, { nonNullable: true }),
      forceTempActive: new FormControl<boolean>(false, { nonNullable: true }),

      Addresses: new FormArray<AddressForm>([]),
      StreetAddress: new AddressForm(),
      MailingAddress: new AddressForm(),

      Contacts: new FormArray<ContactForm>([])
    });
  }
}
